<template>
  <transition name="button-top">
    <div class="btn-float-box">
      <div v-if="isShow" :class="'btn-float btn-top' + voucherClass">
        <a @click.prevent="clickTop()" href="#"><img src="../../assets/images/common/btn-go-top.png" alt="페이지 맨 위로 이동"></a>
      </div>
    </div>
  </transition>
</template>

<script>
import { PATH_NAME_VOUCHER_INDEX, PATH_NAME_VOUCHER_PROMOTION } from '@/common/resources/router.const'

export default {
  data () {
    return {
      isShow: false,
      isScrolling: null
    }
  },
  computed: {
    voucherClass () {
      return this.$route.name === PATH_NAME_VOUCHER_INDEX || this.$route.name === PATH_NAME_VOUCHER_PROMOTION ? ' btn-voucher-float' : ''
    }
  },
  methods: {
    clickTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      let scrolls = document.body.scrollTop || document.documentElement.scrollTop
      this.isShow = scrolls > 100
    }, false)
  }
}
</script>
